import TrainingRequest from "../FrontendComponents/trainingRequest";

const exp = [{
    name: 'TrainingRequest',
    path: '/trainingRequest/:agentId',
    component: TrainingRequest,
    key: 'trainingRequest'
}]
export default exp
